var BRAND = {

    onReady: function() {
        BRAND.readMore();
        BRAND.searchBrands();
        BRAND.searchShops();
        BRAND.searchProducts();
        BRAND.singinModal();
        BRAND.starSelector();
        $('body').on('click', '#loadMoreMessages', BRAND.loadNextPage);
        $('body').on('click', '[data-action="openReportMessage"]', BRAND.openReportMessage);
        $("#ReportMessageModal form").on('submit', BRAND.reportMessage);
        $('body').on('submit', '[data-action="replyToMessage"]', BRAND.replyToMessage);
        $(document).on('submit', '[data-action="updateAnswer"]', BRAND.updateAnswer);
        $('body').on('click', '[data-action="destroyAnswer"]', BRAND.destroyAnswer);
        $('body').on('click', '[data-action="destroyMessage"]', BRAND.openDestroyMessage);
        $('body').on('click', '[data-action="markAsPrivateMessage"]', BRAND.markAsPrivateMessage);
        $('body').on('click', '[data-action="markAsResolvedMessage"]', BRAND.markAsResolvedMessage);
        $('body').on('click', '[data-action="markAsUnresolvedMessage"]', BRAND.markAsUnresolvedMessage);
        $('body').on('click', '[data-action="disableNotificationMessage"]', BRAND.disableNotifications);
        $('body').on('click', '[data-action="enableNotificationMessage"]', BRAND.enableNotifications);
        $('body').on('click', '[data-action="openShareMessage"]', BRAND.openShareMessage);
        $('body').on('click', '[data-action="editAnswer"]', BRAND.editAnswer);
        $('body').on('submit', '#signin, #signupPost', BRAND.auth);
        $('body').on('submit', '#DestroyMessageFormForm', BRAND.destroyMessage);
        $('body').on('change', '#PublishBox input[name="is_public"]', BRAND.isPublicToggle);
        $('body').on('click', '#PublishBox input[type="reset"]', BRAND.resetRedactorBox);
    },
    starSelector: function (){
        const note =  $('input[name="rating_note"]').val();
        $('#StarSelector').children().removeClass( function (index, css) {
            return (css.match (/(^|\s)starSel\S+/g) || []).join(' ');
        });
        $('.StarReview[data-value="'+ note +'"]').addClass( 'starSel'+ note );
        $('.StarReview[data-value="'+ note +'"]').nextAll().addClass( 'starSel'+ note );

        $(".StarReview").click( function(){
            $('#rating_note').val($(this).data('value'))
            $('#StarSelector').children().removeClass( function (index, css) {
                return (css.match (/(^|\s)starSel\S+/g) || []).join(' ');
            });
            $(this).addClass( 'starSel'+ $(this).data('value') );
            $(this).nextAll().addClass( 'starSel'+ $(this).data('value') );
        });
    },

    isPublicToggle: function() {
        var el = $(this);
        if (el.is(':checked')) {
            $(".mode-switch > span").html(el.data('checked'));
        }
        else {
            $(".mode-switch > span").html(el.data('unchecked'));
        }
    },

    searchBrands: function () {
        if ($("form#search input").length) {
            $("form#search input").autocomplete({
                minLength: 2,
                source: $('form#search').attr('action'),
                select: function (event, ui) {
                    if(ui.item.slug === 'add_business') return false;
                    window.location.href = ui.item.url;
                },
                search: function () {
                    $(this).addClass('working');
                },
                open: function(){
                    $(this).removeClass('working');
                }
            }).autocomplete("instance")._renderItem = function (ul, item) {
                ul.addClass('searh-autocomplete');
                if (item.slug === 'add_business') {
                    return $("<li>")
                        .append(`
                            <div class="no-brand-wr">
                                <div class="flex sm:flex-row flex-col items-center pt-4 no-brand-res">
                                    <div>${item.add_your_business}</div>
                                    <a href="https://fr.custplace.com/espace-certification/?utm_source=reviewjobs&utm_medium=header_search"  class="custGradient plusIcon relative text-white text-rs xss:text-sm font-semibold px-3 mt-2 sm:mt-0 xss:pl-10 xss:pr-4 py-2 rounded-sm sm:ml-auto">
                                        ${item.label}
                                    </a>
                                </div>
                            </div>
                        `)
                        .appendTo(ul);
                }
                else {
                    return $("<li>")
                        .append(
                            `<a href="${item.url}" class="flex items-center rounded-sm">
                                <div>
                                    <div class="flex items-center space-x-2 text-sm leading-tight font-normal mb-2px">
                                        <strong class="uppercase">${item.label}</strong>
                                         ${item.voters_count ? 
                                            `<span class="font-medium">
                                                ${item.voters_count}
                                                <span class="text-gray-750">${item.voters}</span>
                                            </span>` 
                                        : ``}  
                                    </div>
                                    ${item.note > 0 ? `
                                    <div class="flex items-center space-x-2">
                                        <div class="aggregateRating sm-agg s-${Math.floor(item.note)}">
                                            <span class="agg-selected-inner" style="width: ${item.note /5 * 100 }% !important;"></span>
                                        </div>
                                        <div class="text-sm font-normal">
                                            <span class="font-medium">${item.note}</span><span class="text-gray-750 ml-1">/ 5</span>
                                        </div>
                                    </div>` : `` }
                                </div>
                                <div class="ml-auto">
                                    <svg class="h-4" viewBox="0 0 20 20">
                                        <g stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                                            <path d="M18 3v4c0 2-2 4-4 4H2"></path><path d="M8 17l-6-6 6-6"></path>
                                        </g>
                                    </svg>
                                </div>
                            </a>`
                        )
                        .appendTo(ul);
                }
            };
        }
    },

    searchShops: function () {
        if ($("#shopAutocomplete").length) {
            $("#shopAutocomplete").autocomplete({
                minLength: 3,
                source: function (request, response) {
                    $.ajax({
                        url: `/${AppCountry}/search/shop`,
                        dataType: "json",
                        data: {
                            term: request.term,
                            brand_id: $('#PublishBox [name="brand_id"]').val()
                        },
                        success: function (data) {
                            response(data);
                        }
                    });
                },
                select: function (event, ui) {
                    $("#shopAutocomplete").val(ui.item.label);
                    $("#PlaceId").val(ui.item.place_id);
                    $('input[name="shop_id"]').val(ui.item.id);
                    return false;
                },
                search: function (event, ui) {
                    $("#shopAutocomplete").parent('fieldset').toggleClass('loading');
                },
                response: function (event, ui) {
                    $("#shopAutocomplete").parent('fieldset').toggleClass('loading');
                }
            });
        }
    },

    searchProducts: function () {
        if ($("#productAutocomplete").length) {
            $("#productAutocomplete").autocomplete({
                minLength: 3,
                source: function (request, response) {
                    $.ajax({
                        url: '/search/product',
                        dataType: "json",
                        data: {
                            term: request.term,
                            brand_id: $('#PublishBox [name="brand_id"]').val()
                        },
                        success: function (data) {
                            response(data);
                        }
                    });
                },
                select: function (event, ui) {
                    $("#productAutocomplete").val(ui.item.label);
                    $("#ProductId").val(ui.item.id);
                    return false;
                },
                search: function (event, ui) {
                    $("#productAutocomplete").parent('fieldset').toggleClass('loading');
                },
                response: function (event, ui) {
                    $("#productAutocomplete").parent('fieldset').toggleClass('loading');
                }
            });
        }
    },

    readMore: function () {
        //if ($('#about_sidebar').length)  {
            $('#about_sidebar').readmore({
                collapsedHeight: 140,
                speed: 600,
                lessLink: '<a href="#">' + $('#about_sidebar').data('less') + '</a>',
                moreLink: '<a href="#">' + $('#about_sidebar').data('more') + '</a>',
                embedCSS: false
            });
        //}
    },

    singinModal: function () {
        $("#sign-in, #flag-post, #share-post").on("click", function () {
            $("body").addClass("modal-open");
        });

        $(document).on("click", ".modal-fade-screen, .modal-close", function () {
            $(".modal-state:checked").prop("checked", false).change();
            $("body").removeClass("modal-open");
        });

        $("#LoginModal .modal-inner, #ReportMessageModal .modal-inner, #SharePostModal .modal-inner").on("click", function(e) {
            e.stopPropagation();
        });
    },

    resetRedactorBox: function () {
        $('.publish-box').hide();
    },

    loadNextPage: function () {
        var el = $(this);
        function toggleLoading() {
            el.find('.send').toggleClass('hidden inline-block')
            el.find('.loading').toggleClass('hidden block')
        }
        $.ajax({
            url: el.attr('href'),
            type: 'get',
            dataType: 'html',
            beforeSend: function() {
                toggleLoading()
            },
            success: function(data) {
                // Remove old pagination link
                el.remove();
                $("#spacer").remove();
                // Append html
                var html = $("#messages-box").append(data);
                // Apply autosize for textareas
                autosize(html.find('textarea[name="message"]'));
            },
            error: function() {
                console.log('Error 101.');
            },
            complete: function() {
                toggleLoading()
            }
        });
        return false;
    },

    openReportMessage: function () {
        var el = $(this);
        $("#flag-post").not(':checked').prop("checked", true);
        $('#ReportMessageModal input[name="message_id"]').val(el.data('id'));
    },

    openShareMessage: function () {
        var el = $(this);
        $.get(el.data('href'), function( data ) {
            $("#ShareMessageModal").html( data );
            $("#share-post").not(':checked').prop("checked", true);
        });
        return false;
    },

    reportMessage: function () {
        var form = $(this);

        function toggleLoading() {
            form.find('[type="submit"] .send').toggleClass('hidden inline-block')
            form.find('[type="submit"] .loading').toggleClass('hidden block')
        }

        $.ajax({
            url: form.attr('action'),
            type: form.attr('method'),
            dataType: 'json',
            data: form.serializeArray(),
            beforeSend: function() {
                toggleLoading()
            },
            success: function(data) {
                $("#flag-post").prop("checked", false);
                $("#ReportMessageModal").toggle();
                console.log(data.message)
                toastr.success('asdasdasdasd')
                toastr.success(data.message);
            },
            error: function(xhr) {
                if( xhr.status === 422 ) {
                    toastr.error(xhr.responseJSON.errors.flag);
                }else {
                    BRAND.displayErrors(form, '', xhr.responseJSON);
                }
            },
            complete: function() {
                toggleLoading()
            }
        });
        return false;
    },

    markAsPrivateMessage: function () {
        var el = $(this);
        $.ajax({
            url: "/fr/messages/" + el.data('id') + "/mark_as_private",
            type: "post",
            dataType: 'json',
            data: {
                message_id: el.data('id'),
                _token: $('[name="csrf_token"]').attr('content'),
            },
            beforeSend: function() {
                el.closest('.topic-sample').toggleClass('run-action');
            },
            success: function(data) {
                $('[data-view="message-'+ el.data('id') +'"]').replaceWith(data.message);
            },
            complete: function() {
                el.closest('.topic-sample').toggleClass('run-action');
            }
        });
        return false;
    },

    markAsResolvedMessage: function () {
        var el = $(this);
        $.ajax({
            url: "/fr/messages/" + el.data('id') + "/mark_as_resolved",
            type: "post",
            dataType: 'json',
            data: {
                message_id: el.data('id'),
                _token: $('[name="csrf_token"]').attr('content'),
            },
            beforeSend: function() {
                el.closest('.topic-sample').toggleClass('run-action');
            },
            complete: function() {
                el.closest('.topic-sample').toggleClass('run-action');
            },
            success: function(data) {
                $('[data-view="message-'+ el.data('id') +'"] h2 a').append('<span>'+ data.tag +'</span>');
                toastr.success(data.message);
            }
        });
        return false;
    },

    markAsUnresolvedMessage: function () {
        var el = $(this);
        $.ajax({
            url: "/fr/messages/" + el.data('id') + "/mark_as_unresolved",
            type: "post",
            dataType: 'json',
            data: {
                message_id: el.data('id'),
                _token: $('[name="csrf_token"]').attr('content'),
            },
            beforeSend: function() {
                el.closest('.topic-sample').toggleClass('run-action');
            },
            complete: function() {
                el.closest('.topic-sample').toggleClass('run-action');
            },
            success: function(data) {
                $('[data-view="message-'+ el.data('id') +'"] h2 span').remove();
                toastr.success(data.message);
            }
        });
        return false;
    },

    enableNotifications: function () {
        var el = $(this);
        $.ajax({
            url: "/fr/messages/" + el.data('id') + "/enable_notifications",
            type: "post",
            dataType: 'json',
            data: {
                message_id: el.data('id'),
                _token: $('[name="csrf_token"]').attr('content'),
            },
            beforeSend: function() {
                el.closest('.topic-sample').toggleClass('run-action');
            },
            complete: function() {
                el.closest('.topic-sample').toggleClass('run-action');
            },
            success: function(data) {
                toastr.success(data.message);
            }
        });
        return false;
    },

    disableNotifications: function () {
        var el = $(this);
        $.ajax({
            url: "/fr/messages/" + el.data('id') + "/disable_notifications",
            type: "post",
            dataType: 'json',
            data: {
                message_id: el.data('id'),
                _token: $('[name="csrf_token"]').attr('content'),
            },
            beforeSend: function() {
                el.closest('.topic-sample').toggleClass('run-action');
            },
            complete: function() {
                el.closest('.topic-sample').toggleClass('run-action');
            },
            success: function(data) {
                toastr.success(data.message);
            }
        });
        return false;
    },

    displayErrors: function (el, message, errors) {
        el.find('.flash-error, .msg-error').remove();
        // Fields errors
        $.each(errors, function(key, value) {
            el.find('[name="'+key+'"][type!="hidden"]').after('<span class="msg-error block mt-1 text-red-600">'+value[0]+'</span>');
        });
        // Remove errors after 5sec
        setTimeout(function () {
            el.find('.flash-error, .msg-error').remove();
        }, 20000);
    },

    replyToMessage: function () {
        var form = $(this);

        function toggleLoading() {
            form.find('[type="submit"] .send').toggleClass('hidden inline-block')
            form.find('[type="submit"] .loading').toggleClass('hidden block')
        }

        var formData = form.serializeArray();
        // Check if message not empty
        if (formData[3]['value'].trim().length == 0) return false;
        // Send xhr
        $.ajax({
            url: form.attr('action'),
            type: form.attr('method'),
            dataType: 'html',
            data: formData,
            beforeSend: function() {
                toggleLoading()
                form.find('[type="submit"]').prop('disabled', true);
            },
            success: function(data) {
                form.find('textarea[name="message"]').val('');
                // Recalculate textarea autosize
                autosize.update(form.find('textarea[name="message"]'));
                // Insert answer html
                $(data).insertBefore('[data-view="answers-for-' + formData[1]['value'] + '"] .add-answer').slideDown();
            },
            error: function(xhr) {
                if (xhr.status == '401') {
                    // Auth
                    $("#LoginModal").toggle();
                }
                else if (xhr.status == '422') {
                    BRAND.displayErrors(form, '', JSON.parse(xhr.responseText));
                }
                else if (xhr.status == '429') {
                    toastr.error(xhr.responseText);
                }
                else if (xhr.status == '412') {
                    toastr.options.timeOut = 0;
                    toastr.options.extendedTimeOut = 0;
                    toastr.warning(xhr.responseText);
                    form.find('textarea[name="message"]').val('');
                    autosize.update(form.find('textarea[name="message"]'));
                }
            },
            complete: function() {
                toggleLoading()
                form.find('[type="submit"]').prop('disabled', false);
            }
        });
        return false;
    },

    storeMessage: function (form) {
        var formData = form.serializeArray();
        // Send xhr
        $.ajax({
            url: form.attr('action'),
            type: form.attr('method'),
            dataType: 'json',
            data: formData,
            beforeSend: function() {
                form.find('[type="submit"]').toggleClass('loading');
                form.find('[type="submit"]').prop('disabled', true);
            },
            success: function(data) {
                // Reset form
                $('.publish-box').hide();
                form.find('[type="reset"]').click();
                // Append new message
                var message = $("#messages-box").prepend(data.body);
                autosize(message.find('textarea[name="message"]'));
                // Display flash message
                $(".left-container").prepend(data.flash);
                setTimeout(function () {
                    $('.flash-error, .flash-success, .msg-error').remove();
                }, 20000);
                // Scroll to top
                $("html, body").animate({ scrollTop: 0 }, "slow");
            },
            error: function(xhr) {
                if (xhr.status == '401') {
                    // Display signin modal
                    $("#sign-in").prop("checked", true);
                }
                else if (xhr.status == '422') {
                    BRAND.displayStoreMessageErrors(form, xhr.responseJSON);
                }
                else if (xhr.status == '429') {
                    toastr.error(xhr.responseJSON.message);
                }
            },
            complete: function() {
                form.find('[type="submit"]').toggleClass('loading');
                form.find('[type="submit"]').prop('disabled', false);
            }
        });
        return false;
    },

    editAnswer: function () {
        var el = $(this);
        // Send xhr
        $.ajax({
            url: el.data('route'),
            type: 'get',
            dataType: 'html',
            success: function(data) {
                el.closest('.topic-sample').toggleClass('loading');
                var new_el = $('[data-view="answer-'+el.data('id')+'"] .topic-content').replaceWith(data);
                autosize($('textarea'));
            },
            beforeSend: function() {
                el.closest('.topic-sample').toggleClass('loading');
            },
            complete: function() {
                el.closest('.topic-sample').toggleClass('loading');
            }
        });
        return false;
    },

    updateAnswer: function () {
        var form = $(this);

        function toggleLoading() {
            form.closest('.topic-sample').toggleClass('ralative run-action');
            form.find('[type="submit"] .send').toggleClass('hidden inline-block')
            form.find('[type="submit"] .loading').toggleClass('hidden block')
        }

        var formData = form.serializeArray();
        // Check if message not empty
        if (formData[1]['value'].trim().length == 0) return false;
        // Send xhr
        $.ajax({
            url: form.attr('action'),
            type: form.attr('method'),
            dataType: 'json',
            data: formData,
            beforeSend: function() {
                toggleLoading()
                form.find('[type="submit"]').prop('disabled', true);
            },
            success: function(data) {
                form.closest('.topic-sample').replaceWith(data.data);
                toastr.success(data.message);
            },
            error: function(xhr) {
                if (xhr.status == '401') {
                    $("#sign-in").prop("checked", true);
                }
                else if (xhr.status == '403') {
                    BRAND.displayErrors(form, '', xhr.responseJSON);
                }
                else if (xhr.status == '429') {
                    toastr.error(data.message);
                }
            },
            complete: function() {
                toggleLoading()
                form.find('[type="submit"]').prop('disabled', false);
            }
        });
        return false;
    },

    displayStoreMessageErrors: function (el, errors) {
        // Fields errors
        $.each(errors, function(key, value) {
            if (key == 'rating_note')
                el.find('.note-smiley').after('<span class="text-red-700 msg-error">'+value[0]+'</span>');
            else
                el.find('[name="'+key+'"][type!="hidden"]').after('<span class="text-red-700 msg-error">'+value[0]+'</span>');
        });
    },

    showNotifyMeCheckbox: function () {
        var el = $(this);
        el.parent().find('div.is_notified').toggle();
    },

    destroyAnswer: function () {
        var el = $(this);
        // Send xhr
        $.ajax({
            url: el.data('route'),
            type: 'delete',
            dataType: 'json',
            data: {
                _token: $('[name="csrf_token"]').attr('content'),
                id: el.data('id')
            },
            success: function(data) {
                $('[data-view="answer-'+el.data('id')+'"]').remove();
                toastr.success(data.message);
            },
            beforeSend: function() {
                el.closest('.topic-sample').toggleClass('run-action');
            },
            complete: function() {
                el.closest('.topic-sample').toggleClass('run-action');
            }
        });
        return false;
    },

    openDestroyMessage: function () {
        var el = $(this);
        $.get(el.data('href'), function( data ) {
            $("#DeleteMessageModal").html( data );
            $("#delete-post").not(':checked').prop("checked", true);
        });
        return false;
    },

    destroyMessage: function () {
        var el = $(this);
        // Send xhr
        $.ajax({
            url: el.attr('action'),
            type: 'delete',
            dataType: 'json',
            data: el.serializeArray(),
            success: function (data) {
                $('[data-view="message-' + data.data.id + '"]').remove();
                $("#destroyMessageForm").toggle();
                toastr.success(data.message);
            },
            beforeSend: function () {
                el.closest('.topic-sample').toggleClass('run-action');
            },
            complete: function () {
                el.closest('.topic-sample').toggleClass('run-action');
            }
        });
        return false;
    },

    auth: function (e) {
        var form = $(this);
        var formData = form.serializeArray();
        function toggleLoading() {
            form.find('[type="submit"] .send').toggleClass('hidden inline-block')
            form.find('[type="submit"] .loading').toggleClass('hidden block')
        }
        // Send xhr
        $.ajax({
            url: form.attr('action'),
            type: form.attr('method'),
            dataType: 'json',
            data: formData,
            beforeSend: function() {
                toggleLoading()
            },
            success: function(data) {
                location.reload();
            },
            error: function(xhr) {
                if (xhr.status == '422') {
                    BRAND.displayErrors(form, '', xhr.responseJSON.errors);
                }
                else {
                    location.reload();
                }
            },
            complete: function() {
                toggleLoading()
            }
        });
        return false;
    }
};

$(document).ready(function () {
    // Ready
    BRAND.onReady();

    // delete all inline styling from block seo
    $('.entry-content').children().removeAttr('style');

    // Rating stars
    $(".CustRating").custRating();

    // Autosize for textareas
    autosize(document.querySelectorAll('textarea[name="message"]'));

    // Redactor form validation
    if ($("#PublishBox form").length) {
        $.validate({
            form: '#PublishBox form',
            errorMessageClass: 'msg-error',
            scrollToTopOnError: false,
            onSuccess: function ($form) {
                BRAND.storeMessage($form);
                return false;
            },
            onElementValidate: function (valid, $el, $form, errorMess) {
                if ($el.attr('name') == 'rating_note') {
                    $('div.note-smiley ul').append('<span class="msg-error">' + errorMess + '</span>');
                }
            },
            onError: function ($form) {
                $('div.note-smiley ul li.has-error span.msg-error').remove();
            },
        });
    }

    // Date picker
    $('[data-toggle="datepicker"]').datepicker({
        language: window.AppLocale,
        viewMode    :   "years",
        format: 'yyyy',
        zIndex: 999999,
        'endDate': 'today'
    });

    // Generate review title
    $('#PublishBox form textarea[name="message"]').keyup(function () {
        var message = $(this).val();
        message = message.split('\n', 1)[0];
        var title = message.length <= 50 ? message : message.replace(/^(.{50}[^\s]*).*/, "$1") + ' ...';
        $('#PublishBox form input[name="subject"]').val(title);
    });

    $('#createAccountLink').click(function() {
        $('html, body').animate({
            scrollTop: $("#createAccount").offset().top - 40
        }, 500);
        return false;
    });

    // Toastr
    toastr.options = {
        "closeButton": true,
        "debug": true,
        "newestOnTop": true,
        "progressBar": false,
        "positionClass": "toast-bottom-full-width",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300000",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    }
});
